module.exports = __webpack_public_path__ + "media/fonts/ppneuemachina-regular-webfont-c1e8eba8b8a693141d9ac4e899e853d3.woff";